import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Report from "@/pages/Report";
import Success from "@/pages/Success";
import AdminDashboard from "@/pages/AdminDashboard";
import Compare from "@/pages/Compare";
import Zakelijk from "@/pages/Zakelijk";

function App() {
  return (
    <div className="App min-h-screen bg-slate-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/vergelijk" element={<Compare />} />
          <Route path="/zakelijk" element={<Zakelijk />} />
          <Route path="/rapport/:id" element={<Report />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
